import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Box, Typography } from "@mui/material";

const LeadCommunication = ({ communication }) => {
  if (!communication?.id) return;
  return (
    <Box>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Box
          display={"flex"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          gap={2}
        >
          <Box
            sx={{
              width: 25,
              height: 25,
              backgroundColor: "secondary.main",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            textAlign={"center"}
          >
            <MoreHorizIcon sx={{ color: "#fff" }} />
          </Box>
          <Typography color="text.secondary" fontSize={14}>
            Item created
          </Typography>
        </Box>
        <Box>
          <Typography color="text.secondary" fontSize={14}>
            {localStorage.getItem("nice_name") || "admin"}
          </Typography>
        </Box>
      </Box>
      <Box
        key={communication.id}
        p={2}
        border="1px solid #ddd"
        borderRadius={2}
        bgcolor="#fafafa"
        mt={1}
      >
        <Typography variant="caption" color="text.secondary">
          {new Date(communication?.created_at).toLocaleString()}
        </Typography>
        <Typography variant="body2" mt={1} sx={{ whiteSpace: "pre-line" }}>
          {communication?.text}
        </Typography>
      </Box>
    </Box>
  );
};

export default LeadCommunication;
